import seoConfig from './seo-pages.json'

export type SeoPageKey = keyof typeof seoConfig.pages

export const SITE_NAME = seoConfig.siteName
export const SITE_URL = (import.meta.env.VITE_SITE_URL || seoConfig.siteUrl).replace(/\/$/, '')
export const DEFAULT_SOCIAL_IMAGE = seoConfig.defaultImage
export const SEO_PAGES = seoConfig.pages

export function absoluteUrl(path: string) {
  if (/^https?:\/\//i.test(path)) return path
  return new URL(path.startsWith('/') ? path : `/${path}`, `${SITE_URL}/`).toString()
}
